import React from 'react';
import { LabelsConfiguration } from '~/core/configuration/configuration-global-config.type';
import { BasicLabel } from '~/core/results/types/results.schema';
import { getLabelType } from '~/utils/getLabelType';
import { useProductContext } from './productResultContext';
import { ProductResultImageLabel } from './productResultImageLabel';

interface ILabels {
    configuration?: LabelsConfiguration;
    items?: BasicLabel | Array<BasicLabel>;
}

const ProductResultImageLabels: React.FC<ILabels> = ({ configuration, items }) => {
    const { style } = useProductContext();
    if (
        items === undefined ||
        items === '' ||
        (Array.isArray(items) && items.length === 0) ||
        configuration === undefined
    ) {
        return null;
    }

    const labels = Array.isArray(items)
        ? items
              .filter((item) => item.length > 0)
              .map((item, key) => {
                  return (
                      <ProductResultImageLabel
                          text={item}
                          type={getLabelType(configuration, item, 'label-black')}
                          key={key}
                      />
                  );
              })
        : null;

    return <ul className={style.labelsWrapper}>{labels}</ul>;
};

export default ProductResultImageLabels;
